<template>
  <div id="app">
    <!-- 全局认证警告提示 -->
    <div v-if="$store.getters.hasAuthWarning" class="global-auth-warning">
      <div class="warning-content">
        <i class="el-icon-warning"></i>
        <span class="warning-text">{{ $store.getters.authWarningMessage }}</span>
        <div class="warning-actions">
          <el-button type="primary" size="mini" @click="handleRelogin">重新登录</el-button>
          <el-button size="mini" @click="handleIgnore">忽略</el-button>
        </div>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    handleRelogin() {
      // 清除警告状态
      this.$store.dispatch('clearAuthWarning')
      // 跳转到登录页
      this.$router.push('/login')
    },
    handleIgnore() {
      // 只是清除警告，继续使用
      this.$store.dispatch('clearAuthWarning')
    }
  },
  mounted() {
    // 监听全局认证警告事件
    window.addEventListener('auth-warning', (event) => {
      this.$store.dispatch('showAuthWarning', {
        message: event.detail.message,
        type: event.detail.type
      })
    })
  }
}
</script>

<style>
.global-auth-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  padding: 12px 20px;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.warning-content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.warning-text {
  flex: 1;
  margin: 0 16px;
  color: #faad14;
  font-weight: 500;
}

.warning-actions {
  display: flex;
  gap: 8px;
}

/* 自定义认证警告消息样式 */
.auth-warning-message {
  min-width: 300px !important;
}

.auth-warning-message .el-message__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.auth-warning-message .el-message__content::after {
  content: "⚠️";
  margin-left: 8px;
}
</style>
